import type { SVGProps } from 'react'
const SvgLinkedinLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.94 8.06H3V21h3.94zm9.56 0c-2.25 0-2.87.74-3.38 1.69V8.06H9.2V21h3.94v-7.31c0-1.13 0-2.25 1.96-2.25 1.97 0 1.97 1.12 1.97 2.25V21H21v-7.31c0-3.38-.56-5.63-4.5-5.63M4.97 6.94a1.97 1.97 0 1 0 0-3.94 1.97 1.97 0 0 0 0 3.94"
    />
  </svg>
)
export default SvgLinkedinLogo
